// Generated by ReScript, PLEASE EDIT WITH CARE

import * as AuthStore$PorterinFeature from "../domain/store/AuthStore.mjs";
import * as AssetStore$PorterinFeature from "../../../ui/assets/AssetStore.mjs";

var business_requirement_requirement_icon = {
  src: AssetStore$PorterinFeature.businessReq,
  width: 50.0,
  height: 50.0,
  alt: "business requirement icon"
};

var business_requirement_heading = AuthStore$PorterinFeature.SignupRequirement.business_requirement_heading;

var business_requirement_sub_heading = AuthStore$PorterinFeature.SignupRequirement.business_requirement_subheading;

var business_requirement = {
  requirement: /* Business */1,
  requirement_icon: business_requirement_requirement_icon,
  heading: business_requirement_heading,
  sub_heading: business_requirement_sub_heading
};

var personal_requirement_requirement_icon = {
  src: AssetStore$PorterinFeature.personalReq,
  width: 50.0,
  height: 50.0,
  alt: "personal requirement icon"
};

var personal_requirement_heading = AuthStore$PorterinFeature.SignupRequirement.personal_requirement_heading;

var personal_requirement_sub_heading = AuthStore$PorterinFeature.SignupRequirement.personal_requirement_subheading;

var personal_requirement = {
  requirement: /* Personal */0,
  requirement_icon: personal_requirement_requirement_icon,
  heading: personal_requirement_heading,
  sub_heading: personal_requirement_sub_heading
};

var houseshift_requirement_requirement_icon = {
  src: "/images/login/houseshift.svg",
  width: 50.0,
  height: 50.0,
  alt: "houseshift requirement icon"
};

var houseshift_requirement_heading = AuthStore$PorterinFeature.SignupRequirement.houseshift_requirement_heading;

var houseshift_requirement_sub_heading = AuthStore$PorterinFeature.SignupRequirement.houseshift_requirement_subheading;

var houseshift_requirement = {
  requirement: /* HouseShift */2,
  requirement_icon: houseshift_requirement_requirement_icon,
  heading: houseshift_requirement_heading,
  sub_heading: houseshift_requirement_sub_heading
};

var requirement_selection = [
  personal_requirement,
  business_requirement,
  houseshift_requirement
];

var spot_business_requirement_requirement_icon = {
  src: AssetStore$PorterinFeature.businessReq,
  width: 50.0,
  height: 50.0,
  alt: "business requirement icon"
};

var spot_business_requirement_heading = AuthStore$PorterinFeature.SignupRequirement.spot_business_requirement_heading;

var spot_business_requirement_sub_heading = AuthStore$PorterinFeature.SignupRequirement.spot_business_requirement_subheading;

var spot_business_requirement = {
  requirement: /* Business */1,
  requirement_icon: spot_business_requirement_requirement_icon,
  heading: spot_business_requirement_heading,
  sub_heading: spot_business_requirement_sub_heading
};

var spot_personal_requirement_requirement_icon = {
  src: AssetStore$PorterinFeature.personalReq,
  width: 50.0,
  height: 50.0,
  alt: "personal requirement icon"
};

var spot_personal_requirement_heading = AuthStore$PorterinFeature.SignupRequirement.spot_personal_requirement_heading;

var spot_personal_requirement_sub_heading = AuthStore$PorterinFeature.SignupRequirement.spot_personal_requirement_subheading;

var spot_personal_requirement = {
  requirement: /* Personal */0,
  requirement_icon: spot_personal_requirement_requirement_icon,
  heading: spot_personal_requirement_heading,
  sub_heading: spot_personal_requirement_sub_heading
};

var spot_requirement_selection = [
  spot_business_requirement,
  spot_personal_requirement
];

export {
  business_requirement ,
  personal_requirement ,
  houseshift_requirement ,
  requirement_selection ,
  spot_business_requirement ,
  spot_personal_requirement ,
  spot_requirement_selection ,
}
/* No side effect */
